import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { DELETE_DIET_CATEGORY_MUTATION } from '../graphql/mutations'
import { DELETE_DIET_CATEGORY } from '../redux/action-types'

const useDeleteDietCategoryMutation = refetchLastEvent => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(
    store => store.diets.dietsAndDietCategories,
  )

  const mutate = useCallback(
    async id => {
      await apolloService.mutate(
        DELETE_DIET_CATEGORY_MUTATION,
        {
          id,
        },
        dispatch,
        DELETE_DIET_CATEGORY,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useDeleteDietCategoryMutation
